// Google's carousel rules need every ListItem URL on this site, so ranking items point at
// their own section heading ("### 1. AgencyZoom, …" renders id="_1-agencyzoom-…"), or, in a
// guide that ranks tools only in a table, at the row's link ("[AgencyZoom](…){#_1-agencyzoom}").
export const rankingHeadingIds = (node, ids = []) => {
  if ((node?.tag === 'h3' || node?.tag === 'a') && node.props?.id) ids.push(node.props.id);
  for (const child of node?.children || []) rankingHeadingIds(child, ids);
  return ids;
};

// Mirrors how @nuxtjs/mdc builds heading ids (github-slugger, then repeated hyphens collapsed):
// punctuation is dropped, not turned into a hyphen, so "Groomer.io" is "groomerio".
export const slugifyName = (name) =>
  String(name)
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s_-]/gu, '')
    .replace(/\s/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

export const rankingAnchor = (item, headingIds) => {
  const name = slugifyName(item.name);
  return headingIds.find((id) => id.startsWith(`_${item.position}-${name}`));
};
